import { render, staticRenderFns } from "./Step2.vue?vue&type=template&id=563ba83e&scoped=true&"
import script from "./Step2.vue?vue&type=script&lang=js&"
export * from "./Step2.vue?vue&type=script&lang=js&"
import style0 from "./Step2.vue?vue&type=style&index=0&id=563ba83e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563ba83e",
  null
  
)

export default component.exports